const CHECK_EVENT_MANAGER_DELAY_MS = 50;
const CHECK_EVENT_MANAGER_TIMEOUT_S = 60;
const MILLISECONDS_IN_SECOND = 1000;
const NOT_FOUND_ERROR_MESSAGE = `manomano-sf portal event manager has not be found after ${CHECK_EVENT_MANAGER_TIMEOUT_S}s`;

export default async function waitForPortalEventManager() {
  return new Promise((resolve, reject) => {
    let checkIntervalId;

    const checkTimeoutId = setTimeout(() => {
      clearInterval(checkIntervalId);
      reject(new Error(NOT_FOUND_ERROR_MESSAGE));
    }, CHECK_EVENT_MANAGER_TIMEOUT_S * MILLISECONDS_IN_SECOND);

    checkIntervalId = setInterval(() => {
      const portalEventManager = window?.manomano?.portal?.eventManager;

      if (portalEventManager !== undefined) {
        clearInterval(checkIntervalId);
        clearTimeout(checkTimeoutId);
        resolve(portalEventManager);
      }
    }, CHECK_EVENT_MANAGER_DELAY_MS);
  });
}
